<div *ngIf="!templateContent && questions" class="main container">
	<h1>{{LOCALIZATION.faqFull}}</h1>
	<div class="well">
		<div *ngFor="let category of questions | keyvalue">
		    <b>{{ category.key }}</b>
		
		    <ul style="list-style:none">
		        <li *ngFor="let item of category.value | keyvalue">
		            <a class="pointMe" (click)="jumpToLocation(item.key)">
		                {{ item.value.question }}
		            </a>
		        </li>
		    </ul>
		</div>
	</div>
	<hr>
	<div *ngFor="let category of questions | keyvalue">
		<div *ngFor="let item of category.value | keyvalue" id="{{ item.key }}" (click)='toggleExpand(item.key)' class="pointMe">
			<div> 
				<span class="lead">{{item.value.question}}</span>
				<i class="fa pull-right" [ngClass]="{'fa-caret-down' : expandedKeys !== item.key, 'fa-caret-up' : expandedKeys === item.key}"></i>
			</div>
			<div *ngIf='expandedKeys == item.key' class="well">
				<p>{{item.value.answer}}</p>
			</div>
			<hr>
		</div>
	</div>	
</div>
<div *ngIf="templateContent" [innerHTML]="templateContent" class="main container"></div>
